
<div class="app-info">
  <div class="d-flex justify-content-between">
    <BuildNumber />
    <UserInfo class="ml-2" />
    <NodeStatus class="ml-2" />
  </div>
</div>
